export function doCopy (text) {
  if (text == null || typeof text.toString !== 'function') {
    return
  }
  var s = text.toString()
  this.$copyText(s).then((e) => {
    this.$message({
      message: this.$t('api.textCopied', {
        text: s
      }),
      type: 'success',
      duration: 2000
    })
  }, function (e) {
    console.log(e)
  })
}
